import { base_url } from "../config/config";

const getCandidateEndpoints = () => {
  if (!base_url) {
    return [];
  }

  return [
    `${base_url}/v1/createLoginLogoutRecord`,
    `${base_url}/createLoginLogoutRecord`,
  ];
};

const toUserName = (user = {}) => {
  const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  return fullName || user?.name || "";
};

export const logAuthEvent = async ({ action, user = {}, source = "web" }) => {
  const normalizedAction = String(action || "")
    .trim()
    .toLowerCase();
  if (!["login", "logout"].includes(normalizedAction)) {
    return;
  }

  const endpoints = getCandidateEndpoints();
  if (!endpoints.length) {
    return;
  }

  const payload = {
    userId: user?._id || user?.id || "",
    email: user?.email || "",
    userName: toUserName(user),
    action: normalizedAction,
    source,
  };

  for (const endpoint of endpoints) {
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok || response.status === 201) {
        return;
      }

      if (response.status === 404) {
        continue;
      }
    } catch (error) {
      // Ignore transient failures to avoid blocking auth flow.
    }
  }
};

export const logAuthEventOnExpiry = ({
  user = {},
  source = "token_expired",
}) => {
  const endpoints = getCandidateEndpoints();
  if (!endpoints.length) {
    return;
  }

  const payload = {
    userId: user?._id || user?.id || "",
    email: user?.email || sessionStorage.getItem("userEmail") || "",
    userName: toUserName(user) || sessionStorage.getItem("userName") || "",
    action: "logout",
    source,
  };

  const body = JSON.stringify(payload);

  for (const endpoint of endpoints) {
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        const sent = navigator.sendBeacon(endpoint, blob);
        if (sent) {
          return;
        }
      }

      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
      return;
    } catch (error) {
      // Continue to next candidate endpoint.
    }
  }
};
